import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { closeAlert } from "../../redux/actions/alertAction";
import { useEffect } from "react";

function Alert() {
  const dispatch = useDispatch();
  const alertState = useSelector((state) => state.alert);

  const alertClassName = () => {
    if (alertState.show) {
      if (alertState.type === "success") {
        return "show alert-success";
      } else if (alertState.type === "error") {
        return "show alert-danger";
      }
    }

    return "";
  };

  const onClose = () => {
    dispatch(closeAlert());
  };

  const alertMessage = () => {
    const formattedMessage = alertState.message.split("\n");

    return formattedMessage.map((line, index) => (
      <span key={index}>
        {line}
        {index + 1 < formattedMessage.length && <br />}
      </span>
    ));
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        dispatch(closeAlert());
      }, 2000);
    }
  }, [alertState.show]);

  return (
    <div
      className={"alert alert-dismissible fade " + alertClassName()}
      role="alert"
    >
      {alertMessage()}
      {alertState.show ? (
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onClose}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default Alert;
